<script setup>
import {useQuery} from "@tanstack/vue-query";
import axios from "axios";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {errorToast} from "@/composables/useToasts";
import {watch} from "vue";

const emit = defineEmits(['close']);

const {data, isLoading, isError} = useQuery({
  queryKey: ['tone-of-voice-guide'],
  queryFn: async () => {
    const {data} =await axios.get(`/ajax/v2/content/tone-of-voice-guide`)
    return data.data
  },
})

watch(isError, (newValue) => {
  if (!newValue) {
    return;
  }
  errorToast('There was a problem getting the tone of voice guide, please try again later.');
  emit('close');
})

</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      modal-class="!tw-max-h-[70vh]"
      @close="emit('close')"
    >
      <div class="tw-justify-items-center">
        <LoadingBlock v-if="isLoading" />

        <div
          v-else-if="data"
          class="tw-prose tw-w-full tw-max-w-full"
          v-html="data.guide"
        />
      </div>
    </BaseModal>
  </Teleport>
</template>
